// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as WalletRepoConfig from "./WalletRepoConfig.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";

var dummyWalletTransactionsResponse = {
      "balance_amount": 28497.22,
      "txns": [
        {
          "txn_uuid": "TXN_asdfq000000",
          "amount": 48.23,
          "title": "DRYRUN INCENTIVE",
          "subtitle": "For CRN00000000",
          "status": "COMPLETED",
          "status_reason": null,
          "ts": 1554543981,
          "txn_type": "DEFAULT",
          "admin_email": "test@xyz.com",
          "admin_comment": "edit order",
          "order_id": "CRN00000000",
          "campaign_id": "CAM111111111"
        },
      ],
      "txn_offset_value": 0,
      "wallet_version_id": 1
    };

var dummyTransactionReasons = {
        "reason": {
          "credit":[
            {"id":26,"reason":"Branding Reimbursement"},
            {"id":5,"reason":"Wallet Migration Credit"},
            {"id":7,"reason":"MBG"},
            {"id":8,"reason":"Porter Rewards"},
            {"id":9,"reason":"Insurance Referral"},
            {"id":10,"reason":"Goodwill Bonus"},
            {"id":11,"reason":"Dry Run"},
            {"id":12,"reason":"Toll Tax"},
            {"id":13,"reason":"Road Tax"},
            {"id":14,"reason":"Adjustment against CRN"},
            {"id":15,"reason":"Other Credit"},
            {"id":19,"reason":"Reimbursement - Branding"},
            {"id":20,"reason":"Trip Incentive"},
            {"id":23,"reason":"Partner Referral"},
            {"id":24,"reason":"Customer Referral"}
          ],
          "debit":[
            {"id":27,"reason":"Upfront EMI Insurance Payment"},
            {"id":28,"reason":"EMI Insurance Payment"},
            {"id":29,"reason":"Branding EMI Debit"},
            {"id":6,"reason":"Wallet Migration Debit"},
            {"id":16,"reason":"Re-branding"},
            {"id":17,"reason":"Suspension Fine"},
            {"id":18,"reason":"Other Debit"},
            {"id":62,"reason":"Insurance Premium (Full)"},
            {"id":21,"reason":"Branding Fee"},
            {"id":22,"reason":"Premium Benefits Subscription Fee"},
            {"id":25,"reason":"Registration Fee"}
          ]
        },
        "status":"200"
      };

var dummyAdminTransactionResponse = {
      "reason": null,
      "status": 200
    };

function fetchWallet(_reportRequest, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyWalletTransactionsResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(WalletRepoConfig.WalletTransactionsResponseConverter.execute, result);
                        });
            });
}

function fetchAdminTransactionReasons(_country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyTransactionReasons
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(WalletRepoConfig.WalletTransactionReasonsConverter.execute, result);
                        });
            });
}

function createTransaction(_msisdn, _request, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyAdminTransactionResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(WalletRepoConfig.AdminTransactionResponseConverter.execute, result);
                        });
            });
}

var WalletRepo = {
  dummyWalletTransactionsResponse: dummyWalletTransactionsResponse,
  dummyTransactionReasons: dummyTransactionReasons,
  dummyAdminTransactionResponse: dummyAdminTransactionResponse,
  fetchWallet: fetchWallet,
  fetchAdminTransactionReasons: fetchAdminTransactionReasons,
  createTransaction: createTransaction
};

export {
  WalletRepo ,
  
}
/* WalletRepoConfig Not a pure module */
